export default {"src":"/_next/static/media/sleep.985d1864.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};